import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'sales-portal-nav',
  template: `
    <ul nz-menu nzMode="inline" class="sales-portal-nav">
      <li nz-submenu
          [(nzOpen)]="openMap['sub_turnover']"
          (nzOpenChange)="openHandler('sub_turnover')"
      >
        <span title>
          <svg-icon [iconName]="'sales-portal-turnover.svg'"
                    class="icon"
                    [size]="iconSize"
                    [class.icon-active]="pathName.indexOf('/sales-portal/turnover') > -1"
                    [isUrl]="false"></svg-icon>
          <span>Turnover</span>
        </span>
        <ul>
          <li nz-menu-item
              [nzSelected]="pathName.indexOf('/sales-portal/turnover') > -1"
              (click)="navigate('/sales-portal/turnover')">
            <svg-icon [iconName]="'sales-portal-overview.svg'"
                      class="icon"
                      [class.icon-active]="pathName.indexOf('/sales-portal/turnover') > -1"
                      [size]="iconSize"
                      [isUrl]="false"
            ></svg-icon>
            <span>Overview</span>
          </li>
          <!--  <li nz-menu-item (click)="navigate('/sales-portal/turnover-target-setting')">
              <svg-icon [iconName]="'sales-portal-target-settings.svg'" class="icon"></svg-icon>
              <span>Target Setting</span>
            </li>-->
        </ul>
      </li>
      <li nz-submenu [(nzOpen)]="openMap['sub_workshop_acquisition']"
          (nzOpenChange)="openHandler('sub_workshop_acquisition')">
        <span title>
          <svg-icon
            [iconName]="'sales-portal-workshop-acquisition.svg'"
            class="icon"
            [size]="iconSize"
            [class.icon-active]="pathName.indexOf('/sales-portal/workshop-acquisition') > -1"
            [isUrl]="false"></svg-icon>
          <span>Workshop Acquisition</span>
        </span>
        <ul>
          <li nz-menu-item
              [nzSelected]="pathName.indexOf('/sales-portal/workshop-acquisition') > -1"
              (click)="navigate('/sales-portal/workshop-acquisition')">
            <svg-icon [iconName]="'sales-portal-overview.svg'"
                      class="icon"
                      [class.icon-active]="pathName.indexOf('/sales-portal/workshop-acquisition') > -1"
                      [size]="iconSize"
                      [isUrl]="false"></svg-icon>
            <span>Overview</span>
          </li>
          <!-- <li nz-menu-item (click)="navigate('/sales-portal/turnover-target-setting')">
             <svg-icon [iconName]="'sales-portal-target-settings.svg'" class="icon"></svg-icon>
             <span>Target Setting</span>
           </li>-->
        </ul>
      </li>
      <li nz-menu-item (click)="navigate('/sales-portal/template')">
        <svg-icon [iconName]="'sales-portal-template.svg'" class="icon"
                  [class.icon-active]="['/sales-portal/template'].includes(pathName)"
                  [size]="iconSize" [isUrl]="false"></svg-icon>
        <span>Template</span>
      </li>
      <li nz-menu-item (click)="navigate('/sales-portal/dealer-allocation')">
        <svg-icon [iconName]="'sales-portal-dealer-allocation.svg'" class="icon"
                  [class.icon-active]="['/sales-portal/dealer-allocation'].includes(pathName)"
                  [size]="iconSize"
                  [isUrl]="false"></svg-icon>
        <span>Dealer Allocation</span>
      </li>
    </ul>
  `,
  styleUrls: ['./sales-portal-nav.component.less']

})
export class SalesPortalNavComponent implements OnInit {
  iconSize: number = 16

  openMap: { [name: string]: boolean } = {
    sub_turnover: true,
    sub_workshop_acquisition: false,
  };


  constructor(
    private router: Router,
  ) {
  }

  ngOnInit() {
    if (location.pathname.indexOf('/sales-portal/workshop-acquisition') > -1) {
      this.openHandler('sub_workshop_acquisition')
    } else if (location.pathname.indexOf('/sales-portal/turnover') > -1) {
      this.openHandler('sub_turnover')
    }
  }

  get pathName() {
    return location.pathname
  }

  navigate(path: string): void {
    this.router.navigate([path]);
  }


  openHandler(value: string): void {
    for (const key in this.openMap) {
      this.openMap[key] = key === value;
    }
  }
}
